import { getLang } from '../i18n';
import { getAreaId } from './area';

/** Lädt eine Datei vom Server (mit Sprache und Bereich im Header) und speichert sie im Browser. */
export async function download(path: string): Promise<void> {
  const r = await fetch(path, { credentials: 'same-origin', headers: { 'x-lang': getLang(), ...(getAreaId() ? { 'x-area': getAreaId()! } : {}) } });
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error((j as { message?: string }).message ?? `Error ${r.status}`);
  }
  const name = /filename="([^"]+)"/.exec(r.headers.get('content-disposition') ?? '')?.[1] ?? 'export.xlsx';
  const url = URL.createObjectURL(await r.blob());
  const a = Object.assign(document.createElement('a'), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Schickt eine Datei als multipart an den Server (Sprache und Bereich im Header). */
export async function upload<T>(method: 'POST' | 'PUT', path: string, file: File, fields: Record<string, string> = {}): Promise<T> {
  const body = new FormData();
  // Felder vor der Datei, damit der Server sie beim Lesen der Datei schon kennt
  for (const [k, v] of Object.entries(fields)) body.append(k, v);
  body.append('file', file, file.name);
  const r = await fetch(path, { method, body, credentials: 'same-origin', headers: { 'x-lang': getLang(), ...(getAreaId() ? { 'x-area': getAreaId()! } : {}) } });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error((j as { message?: string }).message ?? `Error ${r.status}`);
  return j as T;
}

/** Öffnet eine Datei vom Server in einem neuen Tab (z. B. PDF). */
export async function openFile(path: string): Promise<void> {
  const w = window.open('', '_blank');
  const r = await fetch(path, { credentials: 'same-origin', headers: { 'x-lang': getLang(), ...(getAreaId() ? { 'x-area': getAreaId()! } : {}) } });
  if (!r.ok) { w?.close(); const j = await r.json().catch(() => ({})); throw new Error((j as { message?: string }).message ?? `Error ${r.status}`); }
  const url = URL.createObjectURL(await r.blob());
  if (w) w.location.href = url; else location.href = url;
}

/** Holt eine Datei vom Server als File (z. B. PDF aus dem Posteingang für das Bestellformular). */
export async function fetchFile(path: string, name: string, type = 'application/pdf'): Promise<File> {
  const r = await fetch(path, { credentials: 'same-origin', headers: { 'x-lang': getLang(), ...(getAreaId() ? { 'x-area': getAreaId()! } : {}) } });
  if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error((j as { message?: string }).message ?? `Error ${r.status}`); }
  return new File([await r.blob()], name, { type });
}

/** Schickt JSON per POST und speichert die Antwort als Datei (z. B. PowerPoint des Berichts). */
export async function downloadPost(path: string, body: unknown, fallback = 'download'): Promise<void> {
  const r = await fetch(path, { method: 'POST', credentials: 'same-origin', body: JSON.stringify(body), headers: { 'content-type': 'application/json', 'x-lang': getLang(), ...(getAreaId() ? { 'x-area': getAreaId()! } : {}) } });
  if (!r.ok) {
    const j = await r.json().catch(() => ({}));
    throw new Error((j as { message?: string }).message ?? `Error ${r.status}`);
  }
  const cd = r.headers.get('content-disposition') ?? '';
  const star = /filename\*=UTF-8''([^;]+)/.exec(cd)?.[1];
  const name = star ? decodeURIComponent(star) : /filename="([^"]+)"/.exec(cd)?.[1] ?? fallback;
  const url = URL.createObjectURL(await r.blob());
  const a = Object.assign(document.createElement('a'), { href: url, download: name });
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
